import { Controller } from "@hotwired/stimulus"

// Dokumentenvorlage bearbeiten: unterscheidet "nur Metadaten speichern"
// (z. B. Angebotstyp zuweisen) von "neue Datei hochladen + live schalten".
// Ohne ausgewaehlte Datei -> Button "Speichern", Live-Warnung versteckt.
// Mit Datei -> Button "Hochladen und live schalten", Live-Warnung sichtbar.
export default class extends Controller {
  static targets = ["file", "submit", "liveWarning"]
  static values = { uploadLabel: String, saveLabel: String }

  connect() {
    this.refresh()
  }

  refresh() {
    const hasFile =
      this.hasFileTarget && this.fileTarget.files && this.fileTarget.files.length > 0

    if (this.hasSubmitTarget) {
      this.submitTarget.value = hasFile ? this.uploadLabelValue : this.saveLabelValue
    }
    if (this.hasLiveWarningTarget) {
      this.liveWarningTarget.classList.toggle("hidden", !hasFile)
    }
  }
}
